// Country-specific testimonials — realistic names, roles, and quotes

export const COUNTRY_TESTIMONIALS = {
  france: [
    {
      name: 'Sophie Marchand',
      role: 'Propriétaire à Lyon',
      avatar: 'SM',
      avatarBg: '#002654',
      rating: 5,
      quote: 'J\'ai généré mon bail ALUR en moins de 20 minutes. Avant, je payais un notaire 180 € pour la même chose. La qualité du document est vraiment professionnelle.',
      detail: 'Appartement T3, Lyon 6e',
    },
    {
      name: 'Pierre-Antoine Dubois',
      role: 'Bailleur particulier, Paris',
      avatar: 'PD',
      avatarBg: '#003D7A',
      rating: 5,
      quote: 'Tous les diagnostics DDT sont bien intégrés, la clause IRL aussi. Mon locataire a été rassuré par le sérieux du document. Je recommande vivement.',
      detail: 'Studio meublé, Paris 11e',
    },
    {
      name: 'Marie-Claire Fontaine',
      role: 'Gestionnaire immobilière',
      avatar: 'MF',
      avatarBg: '#C41E3A',
      rating: 5,
      quote: 'J\'utilise RentyDoc pour tous mes bailleurs. Gain de temps considérable. Le choix de modèle est un vrai plus pour les propriétaires qui veulent un document soigné.',
      detail: '12 biens gérés à Bordeaux',
    },
  ],

  uk: [
    {
      name: 'James Whitfield',
      role: 'Private Landlord, Manchester',
      avatar: 'JW',
      avatarBg: '#1B2A4A',
      rating: 5,
      quote: 'Generated a fully compliant AST in under 15 minutes. It covered the deposit protection scheme, right to rent checks, and "How to Rent" guide — everything the housing act requires.',
      detail: '2-bed flat, Manchester City Centre',
    },
    {
      name: 'Sarah Pemberton',
      role: 'Property Manager, London',
      avatar: 'SP',
      avatarBg: '#2B3F6B',
      rating: 5,
      quote: 'I manage 8 properties in London and used to spend hours on paperwork. RentyDoc has cut that down dramatically. The tenancy agreements are solid and my tenants trust them.',
      detail: '8 properties across South London',
    },
    {
      name: 'Alistair MacPherson',
      role: 'Buy-to-Let Investor, Edinburgh',
      avatar: 'AM',
      avatarBg: '#1B2A4A',
      rating: 5,
      quote: 'Scotland\'s Private Residential Tenancy rules are different from England and RentyDoc handles that correctly. Saved me a solicitor visit. Very impressed.',
      detail: 'Portfolio of 4 flats, Edinburgh',
    },
  ],

  canada: [
    {
      name: 'Isabelle Tremblay',
      role: 'Propriétaire, Montréal',
      avatar: 'IT',
      avatarBg: '#C41E3A',
      rating: 5,
      quote: 'J\'avais besoin d\'un bail conforme à la loi québécoise. RentyDoc a tout inclus — les clauses spécifiques au RBQ, le dépôt de sécurité réglementaire. Parfait.',
      detail: 'Duplex, Plateau-Mont-Royal',
    },
    {
      name: 'David Chen',
      role: 'Landlord, Toronto',
      avatar: 'DC',
      avatarBg: '#8B1528',
      rating: 5,
      quote: 'Ontario\'s Standard Lease can be confusing. RentyDoc walked me through every section and generated a clean, professional document. My tenant signed it the same day.',
      detail: 'Condo unit, Downtown Toronto',
    },
    {
      name: 'Priya Sharma',
      role: 'Property Investor, Vancouver',
      avatar: 'PS',
      avatarBg: '#C41E3A',
      rating: 5,
      quote: 'BC tenancy law is strict and I needed to get it right. The questionnaire asked exactly the right questions. I\'ve used it for 3 properties now.',
      detail: '3 rental properties, Vancouver',
    },
  ],

  germany: [
    {
      name: 'Klaus Bauer',
      role: 'Vermieter, München',
      avatar: 'KB',
      avatarBg: '#2C2C2C',
      rating: 5,
      quote: 'Mietvertrag nach BGB in 15 Minuten fertig. Die Mietpreisbremse und die Schönheitsreparaturklauseln sind korrekt eingebunden. Ich hätte sonst einen Anwalt gebraucht.',
      detail: '3-Zimmer-Wohnung, München Schwabing',
    },
    {
      name: 'Anna Müller',
      role: 'Vermieterin, Berlin',
      avatar: 'AM',
      avatarBg: '#1a1a1a',
      rating: 5,
      quote: 'In Berlin sind die Vorschriften besonders streng. RentyDoc hat die Berliner Mietendeckel-Regelungen richtig berücksichtigt. Sehr professionelles Dokument.',
      detail: 'Altbauwohnung, Prenzlauer Berg',
    },
    {
      name: 'Thomas Hoffmann',
      role: 'Immobilienverwalter, Hamburg',
      avatar: 'TH',
      avatarBg: '#333333',
      rating: 5,
      quote: 'Ich nutze RentyDoc für alle meine Vermieter. Die drei Vorlagen sehen wirklich professionell aus — besonders die moderne. Kein Vergleich zu den alten Word-Vorlagen.',
      detail: '6 Objekte in Hamburg',
    },
  ],

  spain: [
    {
      name: 'Carlos García Martínez',
      role: 'Propietario, Madrid',
      avatar: 'CG',
      avatarBg: '#c00000',
      rating: 5,
      quote: 'Contrato de arrendamiento conforme a la LAU en minutos. Incluye todas las cláusulas de la ley de vivienda 2023. Mi inquilino quedó muy tranquilo con el documento.',
      detail: 'Piso de 3 habitaciones, Salamanca',
    },
    {
      name: 'Marta Sánchez Ruiz',
      role: 'Gestora inmobiliaria, Barcelona',
      avatar: 'MS',
      avatarBg: '#9b0000',
      rating: 5,
      quote: 'Trabajo con muchos propietarios en Cataluña. RentyDoc genera contratos que cumplen tanto la legislación estatal como la autonómica. Muy recomendable.',
      detail: 'Cartera de 15 pisos, Barcelona',
    },
    {
      name: 'Javier López Torres',
      role: 'Inversor inmobiliario, Valencia',
      avatar: 'JL',
      avatarBg: '#c00000',
      rating: 5,
      quote: 'Tengo varios pisos en Valencia y pagaba 200€ por contrato al gestor. Con RentyDoc hago lo mismo en 15 minutos y con mejor resultado. Excelente servicio.',
      detail: '4 viviendas en alquiler, Valencia',
    },
  ],

  italy: [
    {
      name: 'Marco Esposito',
      role: 'Proprietario, Roma',
      avatar: 'ME',
      avatarBg: '#009246',
      rating: 5,
      quote: 'Contratto 4+4 conforme alla legge 431/98 generato in pochi minuti. Ho incluso tutte le clausole sull\'aggiornamento ISTAT. Davvero comodo e professionale.',
      detail: 'Appartamento 3 locali, Prati',
    },
    {
      name: 'Giulia Ricci',
      role: 'Agente immobiliare, Milano',
      avatar: 'GR',
      avatarBg: '#007236',
      rating: 5,
      quote: 'Uso RentyDoc per i miei clienti proprietari. Il documento è impeccabile, i miei clienti sono soddisfatti e io risparmio ore di lavoro. Ottimo rapporto qualità-prezzo.',
      detail: 'Studio immobiliare, Brera',
    },
    {
      name: 'Antonio Ferrara',
      role: 'Investitore immobiliare, Napoli',
      avatar: 'AF',
      avatarBg: '#009246',
      rating: 5,
      quote: 'Ho 5 appartamenti a Napoli. Prima pagavo un avvocato per ogni contratto. Ora uso RentyDoc e risparmio almeno 300€ a contratto. Qualità identica, se non migliore.',
      detail: '5 appartamenti in gestione',
    },
  ],

  usa: [
    {
      name: 'Michael Thompson',
      role: 'Landlord, Los Angeles',
      avatar: 'MT',
      avatarBg: '#1B3A5C',
      rating: 5,
      quote: 'California lease law is complex — AB 1482, rent control, habitability disclosures. RentyDoc covered everything. My attorney reviewed it and said it was solid.',
      detail: '2-bed apartment, Silver Lake',
    },
    {
      name: 'Jennifer Rodriguez',
      role: 'Property Manager, San Francisco',
      avatar: 'JR',
      avatarBg: '#2A5A8C',
      rating: 5,
      quote: 'I manage 12 units in SF. The SF rent ordinance clauses and just-cause eviction requirements were all there. Saved me $400 in legal fees on this lease alone.',
      detail: '12 units, Mission District',
    },
    {
      name: 'Robert Kim',
      role: 'Real Estate Investor, San Diego',
      avatar: 'RK',
      avatarBg: '#1B3A5C',
      rating: 5,
      quote: 'Clean, professional document. The lead paint disclosure and military base proximity clauses were pre-filled correctly based on my property address. Impressive.',
      detail: 'Single-family home, La Jolla',
    },
  ],

  australia: [
    {
      name: 'Liam O\'Brien',
      role: 'Landlord, Sydney',
      avatar: 'LO',
      avatarBg: '#00008b',
      rating: 5,
      quote: 'NSW Fair Trading compliant lease generated in under 20 minutes. The bond lodgement details and condition report sections were all there. My PM was impressed.',
      detail: '2-bed unit, Surry Hills',
    },
    {
      name: 'Emma Wilson',
      role: 'Property Investor, Melbourne',
      avatar: 'EW',
      avatarBg: '#000066',
      rating: 5,
      quote: 'Victorian residential tenancy law is strict and RentyDoc got it right. VCAT dispute process, rental increases, urgent repairs — everything was covered properly.',
      detail: '3 investment properties, Richmond',
    },
    {
      name: 'Nathan Nguyen',
      role: 'Landlord, Brisbane',
      avatar: 'NN',
      avatarBg: '#00008b',
      rating: 5,
      quote: 'Queensland tenancy agreement done in minutes. Used to cost me $250 at the property manager. The modern template looks so much better than what they used to give me.',
      detail: 'Townhouse, New Farm',
    },
  ],
};
